const REDIRECT_PATH_EXTENSION = '/magic-extension';

export const getExperiencePath = (isExtension: boolean): string => {
  if (isExtension) {
    return REDIRECT_PATH_EXTENSION;
  }

  return window.location.pathname;
};
